const KM_FETCHING_NODES = 'KM_FETCHING_NODES'
const KM_FETCHING_NODES_SUCCESS = 'KM_FETCHING_NODES_SUCCESS'
const KM_FETCHING_NODES_ERROR = 'KM_FETCHING_NODES_ERROR'
const KM_SET_ACTIVE_NODE = 'KM_SET_ACTIVE_NODE'
const KM_CREATING_NEW_NODE = 'KM_CREATING_NEW_NODE'
const KM_CREATING_NEW_NODE_SUCCESS = 'KM_CREATING_NEW_NODE_SUCCESS'
const KM_CREATING_NEW_NODE_ERROR = 'KM_CREATING_NEW_NODE_ERROR'
const KM_SAVING_NODE = 'KM_SAVING_NODE'
const KM_SAVING_NODE_SUCCESS = 'KM_SAVING_NODE_SUCCESS'
const KM_SAVING_NODE_ERROR = 'KM_SAVING_NODE_ERROR'
const KM_NODE_CHANGED = 'KM_NODE_CHANGED'
const KM_NODE_NOT_CHANGED = 'KM_NODE_NOT_CHANGED'

export function fetchingNodes () {
  return {
    type: KM_FETCHING_NODES,
  }
}

export function fetchingNodesSuccess (nodes) {
  return {
    type: KM_FETCHING_NODES_SUCCESS,
    nodes,
  }
}

export function fetchingNodesError (error) {
  return {
    type: KM_FETCHING_NODES_ERROR,
    error,
  }
}

export function setActiveNode (activeNode) {
  return {
    type: KM_SET_ACTIVE_NODE,
    activeNode,
  }
}

export function creatingNewNode() {
  return {
    type: KM_CREATING_NEW_NODE,
  }
}

export function creatingNewNodeSuccess(newNodeId) {
  return {
    type: KM_CREATING_NEW_NODE_SUCCESS,
    newNodeId,
  }
}

export function creatingNewNodeError(error) {
  return {
    type: KM_CREATING_NEW_NODE_ERROR,
    error,
  }
}

export function savingNode () {
  return {
    type: KM_SAVING_NODE,
  }
}

export function savingNodeSuccess (savedNode) {
  return {
    type: KM_SAVING_NODE_SUCCESS,
    savedNode,
  }
}

export function savingNodeError (error) {
  return {
    type: KM_SAVING_NODE_ERROR,
    error,
  }
}

export function nodeChanged() {
  return {
    type: KM_NODE_CHANGED,
  }
}

export function nodeNotChanged() {
  return {
    type: KM_NODE_NOT_CHANGED,
  }
}

const initialState = {
  nodes: null,
  error: '',
  isFetching: false,
  activeNode: '',
  isSaving: false,
  isChanged: false,
}

export function knowledgeMap (state = initialState, action) {
  switch (action.type) {
    case KM_FETCHING_NODES :
      return {
        ...state,
        isFetching: true,
      }
    case KM_FETCHING_NODES_SUCCESS :
      return {
        ...state,
        isFetching: false,
        nodes: action.nodes,
      }
    case KM_FETCHING_NODES_ERROR :
      return {
        ...state,
        isFetching: false,
        error: action.error
      }
    case KM_SET_ACTIVE_NODE :
      return {
        ...state,
        activeNode: action.activeNode,
      }
    case KM_CREATING_NEW_NODE : 
      return {
        ...state,
        isSaving: true,
      }
    case KM_CREATING_NEW_NODE_SUCCESS :
      return {
        ...state,
        isSaving: false,
        activeNode: action.newNodeId,
      }
    case KM_CREATING_NEW_NODE_ERROR :
      return {
        ...state,
        isSaving: false,
        error: action.error,
      }
    case KM_SAVING_NODE : 
      return {
        ...state,
        isSaving: true,
      }
    case KM_SAVING_NODE_ERROR : 
      return {
        ...state,
        isSaving: false,
        error: action.error,
      }
    case KM_SAVING_NODE_SUCCESS :
      return {
        ...state,
        isSaving: false,
        isChanged: false,
      }
    case KM_NODE_CHANGED : 
      return {
        ...state,
        isChanged: true,
      }
    case KM_NODE_NOT_CHANGED :
      return {
        ...state,
        isChanged: false,
      }
    default :
      return state
  }
}



// WEBPACK FOOTER //
// ./src/redux/modules/knowledgeMap.js